import { Action, ActionType } from "@redux/actionTypes/inLicensedActionType";
import { Reducer } from "redux";

export interface InLicensedListState {
  inLicenseDetailsByPID: inLicenseFormDetailsByPID[];
}
export interface inLicenseFormDetailsByPID {
  licensingCost: number;
  lpbfProfitSharing: number | null;
  lpbfRevenueSharing: number | null;
  currencyId: number;
  lpbfsharingType: string;
  projectId: number;
  projectName: string;
  vendorName: string;
  initiatedDate: string;
  rldCost: number | null;
  pilotBE: number | null;
  pivotalBE: number | null;
  licensedProjectBudgetForms: licensedFormsDetails[];
  inProjectFillingFeesModels: IFilingCostDetails[];
  inLicensedProjectDetails: IinLicensedProjectDetails[];
}

export interface IinLicensedProjectDetails {
  lpdetailId: number;
  projectDetails: string;
}

export interface licensedFormsDetails {
  completionExpectedDate: string;
  lpbudgetFormId: number;
  lpdetailId: number;
  percentOfInLicensingCost: number;
  projectId: number;
}

export interface IFilingCostDetails {
  detailId?: number;
  country: string;
  dosageForm: string;
  packStyle: string;
  strength: string;
  strengthUnit: string;
  packTradeDress: string;
  filingCostId?: number;
  submissionType: string;
  estimatedFilingDate: string;
  estimatedApprovalDate: string;
  estimatedFilingFees: number;
}
export interface UpdateProjectPayload {
  projectName: string;
  projectId: number;
  licensingCost: number;
  lpbfProfitSharing: number;
  lpbfsharingType: string;
  lpbfRevenueSharing: number;
  licensedProjectBudgetForms: IlicensedProjectBudgetFormsDetails[];
  inProjectFillingFeesModels: IinProjectFillingFeesModelsDetails[];
  isdelete: boolean;
}

export interface IlicensedProjectBudgetFormsDetails {
  lpbudgetFormId?: number;
  lpdetailId: number;
  completionExpectedDate: string;
  percentOfInLicensingCost: number;
}

export interface IinProjectFillingFeesModelsDetails {
  detailId: number;
  filingCostId: number;
  submissionType: string;
  estimatedFilingDate: string;
  estimatedApprovalDate: string;
  estimatedFilingFees: number;
}
export interface Iheaders {
  headName: string;
  value: string;
  classname?: string;
}

const initialState = {
  inLicenseDetailsByPID: [],
};

export const inLicenseReducer: Reducer<InLicensedListState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.INLICENSED_DETAIL_BY_PID:
      return {
        ...state,
        inLicenseDetailsByPID: action.payload,
      };
    default:
      return state;
  }
};

export default inLicenseReducer;
